"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var video_preview_1 = require("../video-preview/video-preview");
var pagination_1 = require("../../../js/pagination");
var VideoPreview_vue_1 = __importDefault(require("../video-preview/VideoPreview.vue"));
var NavPagination_vue_1 = __importDefault(require("../nav-pagination/NavPagination.vue"));
var SearchBar_vue_1 = __importDefault(require("../search/components/SearchBar.vue"));
var SearchByTopics_vue_1 = __importDefault(require("../search/components/SearchByTopics.vue"));
var SearchByCongress_vue_1 = __importDefault(require("../search/components/SearchByCongress.vue"));
var SearchByCollections_vue_1 = __importDefault(require("../search/components/SearchByCollections.vue"));
var SearchByTrendingContent_vue_1 = __importDefault(require("../search/components/SearchByTrendingContent.vue"));
var VideoShow_vue_1 = __importDefault(require("../video-show/VideoShow.vue"));
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchPageUrl = '/local/api/videos';
        _this.visiblePageUrl = '/video-library';
        _this.perPage = 12;
        _this.searchTerm = '';
        _this.itemsContainerClasses = ['row', 'p-0'];
        _this.itemWrapperClasses = ['mb-3', 'col-12', 'col-md-6', 'col-lg-4', 'col-xl-3'];
        _this.enablePagination = true;
        _this.page = 1;
        _this.pageParameterName = 'page';
        _this.items = [];
        _this.pagination = null;
        _this.fetchingPage = false;
        _this.filters = {
            onlyFavorited: false,
            topic_ids: [],
            congresses: [],
            collection_ids: [],
        };
        _this.refreshFilters = false;
        _this.refreshSubFilters = false;
        _this.currentItem = {
            currentItemIndex: null,
            currentItemSlug: null,
            hasPrev: false,
            hasNext: false,
        };
        _this.visibleUrlOptions = {
            url: '',
            options: {},
        };
        _this.objectToQuery = function (field, obj, prefix) {
            if (prefix === void 0) { prefix = null; }
            var query = "";
            if (obj) {
                var keys = Object.keys(obj);
                keys.forEach(function (key) {
                    if (Array.isArray(obj[key])) {
                        obj[key].forEach(function (e) {
                            if (field === null) {
                                query += "&" + (prefix !== null && prefix !== void 0 ? prefix : "") + key + "[]=" + e;
                            }
                            else {
                                query += "&" + field + (prefix !== null && prefix !== void 0 ? prefix : "") + "[" + key + "]" + "[]=" + e;
                            }
                        });
                    }
                    else if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
                        query += _this.objectToQuery(field, obj[key], (prefix !== null && prefix !== void 0 ? prefix : "") + "[" + key + "]");
                    }
                    else {
                        if (field === null) {
                            query += "&" + (prefix !== null && prefix !== void 0 ? prefix : "") + key + "=" + obj[key];
                        }
                        else {
                            query += "&" + field + (prefix !== null && prefix !== void 0 ? prefix : "") + "[" + key + "]=" + obj[key];
                        }
                    }
                });
            }
            return query;
        };
        return _this;
    }
    App.prototype.created = function () {
        var _this = this;
        this.searchTerm = this.initialSearchTerm;
        this.filters = Object.keys(this.filters)
            .reduce(function (object, key) {
            var _a;
            var _b;
            return Object.assign(object, (_a = {},
                _a[key] = (_b = _this.initialFilters[key]) !== null && _b !== void 0 ? _b : _this.filters[key],
                _a));
        }, this.filters);
        if (this.enablePagination) {
            var page = (0, pagination_1.getPageFromSearchParams)(this.pageParameterName);
            if (page !== null) {
                this.page = page;
            }
        }
        this.fetchPage(this.page);
        this.$watch(function () { return _this.currentItem.currentItemIndex; }, function () {
            if (_this.currentItem.currentItemIndex !== null && _this.items[_this.currentItem.currentItemIndex]) {
                var newItem = _this.items[_this.currentItem.currentItemIndex];
                _this.showVideoDetails(newItem.preview.slug);
            }
        }, { immediate: true, deep: true });
    };
    Object.defineProperty(App.prototype, "http", {
        get: function () {
            return this.$http;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "videoShowNavbar", {
        get: function () {
            return {
                showNavbar: true,
                showNavButtons: true,
                showCloseButton: true,
                hasNext: this.currentItem.hasNext,
                hasPrev: this.currentItem.hasPrev,
            };
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.emptySearchFilters = function () {
        this.filters = {
            onlyFavorited: false,
            topic_ids: [],
            congresses: [],
            collection_ids: [],
        };
        this.refreshFilters = true;
        this.updateSearchTerm('');
    };
    App.prototype.filtersNotEmpty = function () {
        return !this.searchTerm && !this.filters.onlyFavorited && !this.filters.topic_ids && !this.filters.congresses && !this.filters.collection_ids;
    };
    Object.defineProperty(App.prototype, "filtersAreActive", {
        get: function () {
            return !!(this.searchTerm || this.filters.onlyFavorited
                || (this.filters.topic_ids && this.filters.topic_ids.length)
                || (this.filters.congresses && this.filters.congresses.length)
                || (this.filters.collection_ids && this.filters.collection_ids.length));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "isEmptySearchResult", {
        get: function () {
            return !(this.enablePagination && this.pagination && this.pagination.total);
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.buildUrl = function (relativePath) {
        return this.$http.defaults.baseURL + relativePath;
    };
    App.prototype.updateSearchTerm = function (newSearchTerm) {
        this.searchTerm = newSearchTerm;
        this.page = 1;
        this.fetchPage(this.page);
    };
    App.prototype.updateSearchTopics = function (topicIds) {
        this.filters.topic_ids = topicIds;
        this.page = 1;
        this.filters.congresses = [];
        this.filters.collection_ids = [];
        this.refreshSubFilters = true;
        this.fetchPage(this.page);
    };
    App.prototype.updateSearchCongresses = function (congresses) {
        this.filters.congresses = congresses;
        this.page = 1;
        this.fetchPage(this.page);
    };
    App.prototype.updateSearchCollections = function (collectionIds) {
        this.filters.collection_ids = collectionIds;
        this.page = 1;
        this.fetchPage(this.page);
    };
    App.prototype.fetchPageOne = function () {
        this.page = 1;
        this.fetchPage(this.page);
    };
    App.prototype.fetchPage = function (page) {
        var _a;
        var _this = this;
        this.fetchingPage = true;
        var params = (_a = {
                search: this.searchTerm,
                onlyFavorited: this.filters.onlyFavorited,
                topic_ids: this.filters.topic_ids,
                congresses: this.filters.congresses,
                collection_ids: this.filters.collection_ids
            },
            _a[this.pageParameterName] = page,
            _a.per_page = this.perPage,
            _a);
        var paramsCleared = Object.keys(params)
            .filter(function (key) {
            return !!params[key] && key !== 'per_page';
        })
            .reduce(function (object, key) {
            var _a;
            return Object.assign(object, (_a = {},
                _a[key] = params[key],
                _a));
        }, {});
        var queryString = this.objectToQuery(null, paramsCleared);
        var apiUrl = "".concat(this.fetchPageUrl, "?").concat(queryString);
        paramsCleared = Object.keys(paramsCleared)
            .filter(function (key) {
            return key !== 'page' || paramsCleared[key] > 1;
        })
            .reduce(function (object, key) {
            var _a;
            return Object.assign(object, (_a = {},
                _a[key] = params[key],
                _a));
        }, {});
        queryString = this.objectToQuery(null, paramsCleared);
        this.visibleUrlOptions.options = paramsCleared;
        this.visibleUrlOptions.url = "".concat(this.visiblePageUrl);
        if (queryString) {
            this.visibleUrlOptions.url += "?".concat(queryString);
        }
        window.history.pushState(this.visibleUrlOptions.options, 'Videos', this.visibleUrlOptions.url);
        return this.$http
            .get(apiUrl)
            .then(function (res) {
            if (!res.data) {
                throw new Error('Response data is empty.');
            }
            return res.data;
        })
            .then(this.setPaginatedValues)
            .finally(function () {
            _this.fetchingPage = false;
            _this.refreshFilters = false;
            _this.refreshSubFilters = false;
            if (_this.showItemsDirection) {
                if (_this.showItemsDirection == 'next') {
                    _this.currentItem.currentItemIndex = 0;
                }
                else {
                    _this.currentItem.currentItemIndex = _this.items.length - 1;
                }
                _this.showItemsDirection = null;
            }
        });
    };
    App.prototype.setPaginatedValues = function (data) {
        if (!data.page) {
            return;
        }
        this.setPagination(data.page);
        var items = data.page.data
            .filter(function (rawPreview) {
            return typeof rawPreview.type === 'string';
        })
            .map(function (rawPreview) {
            var item = {
                type: rawPreview.type,
                preview: (0, video_preview_1.createVideoPreview)(rawPreview)
            };
            item.preview.processing = false;
            return item;
        });
        this.items = items;
        this.firstFreshItem = items[0];
    };
    App.prototype.setPagination = function (pagination) {
        this.pagination = new pagination_1.PageBaseV1({
            total: pagination.total,
            per_page: pagination.per_page,
            current_page: pagination.current_page,
            last_page: pagination.last_page,
            next_page_url: pagination.next_page_url,
            prev_page_url: pagination.prev_page_url,
            from: pagination.from,
            to: pagination.to,
        });
    };
    App.prototype.pageChanged = function (scrollToLoaded, newPage) {
        var _this = this;
        if (scrollToLoaded) {
            this.closeVideoDetails();
        }
        this.page = newPage;
        this.fetchPage(newPage)
            .then(function () {
            if (scrollToLoaded) {
                _this.$nextTick(function () {
                    _this.scrollToLoaded();
                });
            }
        });
    };
    App.prototype.scrollToLoaded = function () {
        if (!this.firstFreshItem) {
            return;
        }
        var freshItem = this.$el.querySelector('#item-preview-0');
        if (!freshItem) {
            throw new Error('Could not scroll to preview.');
        }
        window.scrollTo({
            top: freshItem.getBoundingClientRect().top + window.pageYOffset + this.scrollOffset - 80,
            behavior: 'smooth'
        });
    };
    App.prototype.updateItemPreview = function (type, preview) {
        var index = this.items
            .findIndex(function (item) {
            return item.type === type && item.preview.id === preview.id;
        });
        if (index === -1) {
            return;
        }
        this.items.splice(index, 1, {
            type: type,
            preview: preview,
        });
    };
    App.prototype.toggleFavoriteVideo = function (preview) {
        var _this = this;
        if (preview.processing) {
            return;
        }
        preview.processing = true;
        (0, video_preview_1.toggleFavorite)(preview, this.$http)
            .then(function (data) {
            preview.processing = false;
            preview.favorited = data.favorited;
            _this.updateItemPreview('video', preview);
        });
    };
    App.prototype.showVideoDetails = function (currentItemSlug) {
        this.currentItem.currentItemSlug = currentItemSlug;
        var hasPrev = false;
        var hasNext = false;
        var itemsLength = this.items.length;
        var currentItemIndex = this.currentItem.currentItemIndex;
        this.items.forEach(function (item, index) {
            if (item.preview.slug == currentItemSlug) {
                currentItemIndex = index;
                if (index > 0) {
                    hasPrev = true;
                }
                if (index < itemsLength - 1) {
                    hasNext = true;
                }
            }
        });
        if (!hasPrev) {
            hasPrev = this.page > 1;
        }
        if (!hasNext) {
            hasNext = this.pagination !== null && this.page < this.pagination.last_page;
        }
        this.currentItem.currentItemIndex = currentItemIndex;
        this.currentItem.hasPrev = hasPrev;
        this.currentItem.hasNext = hasNext;
    };
    App.prototype.closeVideoDetails = function () {
        this.currentItem.currentItemIndex = null;
        this.currentItem.currentItemSlug = null;
        this.currentItem.hasPrev = false;
        this.currentItem.hasNext = false;
        window.history.pushState(this.visibleUrlOptions.options, 'Videos', this.visibleUrlOptions.url);
    };
    App.prototype.showPrevNextVideo = function (direction) {
        if (direction === void 0) { direction = 'next'; }
        if (this.items.length && this.currentItem.currentItemIndex !== null && this.pagination) {
            //Get next item
            if (direction == 'next') {
                if (this.currentItem.hasNext) {
                    if (this.currentItem.currentItemIndex + 1 >= this.items.length) {
                        if (this.page + 1 <= this.pagination.last_page) {
                            this.showItemsDirection = direction;
                            this.pageChanged(false, this.page + 1);
                            //     this.currentItem.currentItemIndex = 0;
                        }
                    }
                    else {
                        this.currentItem.currentItemIndex++;
                    }
                }
            }
            else {
                //Get prev item
                if (this.currentItem.hasPrev) {
                    if (this.currentItem.currentItemIndex - 1 < 0) {
                        if (this.page - 1 >= 1) {
                            this.showItemsDirection = direction;
                            this.pageChanged(false, this.page - 1);
                            // this.currentItem.currentItemIndex = this.perPage - 1;
                        }
                    }
                    else {
                        this.currentItem.currentItemIndex--;
                    }
                }
            }
        }
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: 0 })
    ], App.prototype, "scrollOffset", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: '' })
    ], App.prototype, "initialSearchTerm", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: [] })
    ], App.prototype, "initialFilters", void 0);
    App = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                VideoShow: VideoShow_vue_1.default,
                SearchByTrendingContent: SearchByTrendingContent_vue_1.default,
                SearchByCollections: SearchByCollections_vue_1.default,
                SearchByCongress: SearchByCongress_vue_1.default,
                SearchByTopics: SearchByTopics_vue_1.default,
                SearchBar: SearchBar_vue_1.default,
                VideoPreview: VideoPreview_vue_1.default,
                NavPagination: NavPagination_vue_1.default,
            }
        })
    ], App);
    return App;
}(vue_1.default));
exports.default = App;
